import { uuid } from './regex';

export const BankingRoutes = {
    path: 'banking',
    externalAccount: {
        path: 'externalAccount',
        details: {
            path: `:externalAccountId(${uuid})`,
            verification: {
                path: 'verify',
            },
        },
        edit: {
            path: 'edit',
        },
    },
    withdrawal: {
        path: 'withdrawal',
    },
    deposit: {
        path: 'deposit',
    },
    statement: {
        path: 'statement',
        transaction: {
            path: ':transactionType/:sourceId',
        },
    },
};
